{
  "document": { "repo": "cgwalters-forge/operator", "number": 1, "resolve": true },
  "legacyQuestions": true,
  "inbox": true
}
